import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import Editor from '@tinymce/tinymce-vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ProjectTable from '../project-listing.vue'
import { mapActions } from 'vuex'
import { Lead_list } from '@/api/leads'
import { contentFileUpload } from '@/api/course-builderapi'
import { getUploadedFilesId } from '@/api/assignment-question'
import { popupFocusFirstInput } from '@/mixins/common/popupFocusFirstInput'

import {
  taskDeleteFromProject,
  taskDelete,
  fetchUserClient,
  priorityList,
  createLog,
  tagList,
  parentTask,
  taskCreate,
  projectList,
  taskTemplateUpdate,
  taskShow,
  taskUpdate,
  taskList,
  livetaskList
} from '@/api/task-project.js'
export const TaskProject = {
  mixins: [popupFocusFirstInput],
  components: {
    draggable,
    'editor': Editor,
    'v-select': vSelect,
    flatPickr,
    ProjectTable
  },
  data () {
    return {
      additionalPopUp: false,
      nonDeletableItems: [],
      DeleteTaskId: '',
      checkTaskDel: false,
      searchName: '',
      popupresponse: false,
      projectList: [],
      projectListMeta: {
        current_page: 1,
        has_next: false,
        limit: 5,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      observerUser: new IntersectionObserver(this.loadMoreProject),
      changedDataForFlatpicker: { dueDate: '' },
      file_repository_id: '',
      RenderKey: true,
      initializeTinyMce: {
        setup: editor => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },

        height: 400,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,

        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
        table alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
      },
      executed: false,
      openUpdateModalDetails: false,
      checklistEditPopup: false,
      checklistEditPopup2: false,
      checkIndex: '',
      itemIndex: '',
      editChecklistName: '',
      tagName: [],
      projectStatusTagId: '',
      showCreateView: false,
      showDataForProject: {},
      parentTaskData: [],
      selectedSubTask: [],
      selectedCRM: [],
      selectedCRMData: [],
      reminderTime: [],
      tagsList: [],
      leadList: [],
      ListOfProject: [],
      selectedProjectsData: [],
      selectedSubTaskData: [],
      selectedProjects: [],
      popupActiveProj: false,
      popupActiveSubTask: false,
      popupActiveCRM: false,
      kanbanActive: false,
      live_update_id: '',
      update_id: '',
      openUpdateModal: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      configdateTimePicker1: {
        enableTime: true,
        //enableSeconds: true,
        noCalendar: false,
        altInput: true,
        minDate: new Date(),
        altFormat: 'j F, Y G:i K',
        dateFormat: 'Y-m-d H:i:S'
      },
      configdateTimePicker3: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: false,
        altInput: true,
        altFormat: 'j F, Y G:i K',
        dateFormat: 'Y-m-d H:i:S'
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        maxDate: '',
        maxTime: '',
        // time_24hr: localStorage.getItem('time') == 2,
        altInput: true,
        altFormat: 'j F, Y G:i K',
        dateFormat: 'Y-m-d H:i:S'
        //altFormat: localStorage.getItem('time') == 2 ? `${localStorage.getItem('date_format')  } H:i:S` : `${localStorage.getItem('date_format')  } h:i:S K`
      },
      typeOfPerson: '',
      typeOfPersonTitle: '',
      responsibleData: [],
      participantData: [],
      observerData: [],
      rows: [],
      checklistRows: [],
      checkBox1: '',
      query_page_user: {
        page: 1
      },
      query_page_client: {
        page: 1
      },
      editedRowIndex: null,
      currentPageUser: '',
      currentPageClient: '',
      showButtonClient: true,
      showButtonUser: true,
      clientList: [],
      userList: [],
      selectedUsers: [],
      selectedClients: [],
      taskData: {
        name: '',
        due_date: '',
        task_priority_id: '',
        comments: '',
        created_by: {},
        details: '',
        is_tracking_active: false,
        clientObserver: [],
        clientParticipant: [],
        clientResponsiblePerson: [],
        userObserver: [],
        userParticipant: [],
        userResponsiblePerson: [],
        from_time: '',
        to_time: '',
        is_template: false,
        checklist: [],
        projectStatusTag: '',
        task_status_id: '',
        project: null,
        tags: [],
        subtask: [],
        leads: [],
        reminder: []
      },
      logs: [
        {
          no_of_days: '',
          no_of_hours: ''
        }
      ],
      logHistory: [],
      priority: [],
      image_url: '',
      tinyMceApi: '',
      selectedTab: null,
      popupActive: false,
      statusActive: false,
      importActive: false,
      // primary: '#41cfdd',
      date: '',
      time: null,
      task: true,
      project: false,
      projectId: '',
      allTaskStatus: [],
      statusname: '',
      selected: [],
      selectedData: [],
      ListOfLiveTaskUpdate: [],
      ListOfTaskUpdate: [],
      meta_template: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta_task: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      sub_meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      leadMeta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      tag_meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      leadQuery: {
        page: 1,
        limit: 10,
        customerId: this.$store.getters.customerId
      },
      query_page_data: {
        page: 1,
        limit: 5
      },
      options: [
        { id: 1, status: 'To Do' },
        { id: 2, status: 'In Progress' },
        { id: 3, status: 'Done' }
      ],
      editorComponent: null,
      isBrowseContent: false
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${customer_id}`
    this.checkPermissionForStaff()
  },
  watch: {
    popupActive: {
      deep: true,
      handler () {
        if (!this.popupActive) {
          this.searchName = ''
          this.fetchClient()
          this.fetchUser()
        }
      }
    },
    popupresponse: {
      deep: true,
      handler () {
        if (!this.popupresponse) {
          this.searchName = ''
          this.fetchClient()
          this.fetchUser()
        }
      }
    }
  },
  methods: {
    ...mapActions(['SET_ADD_ID']),
    checkTask (id) {
      this.DeleteTaskId = id
      this.checkTaskDel = true
    },
    close () {
      this.checkTaskDel = false
    },
    async RemoveTask () {
      try {
        const deleting_id = this.DeleteTaskId
        const payload = {
          task_id: deleting_id,
          project_id: this.$route.params.id
        }
        await taskDeleteFromProject(payload)
        this.getAllTask()
        console.log(this.projectDetailsData)
        this.$vs.notify({
          title: 'Task Deleted',
          text: 'Task has been successfully removed from project ',
          ...this.successProp()
        })

        //this.projectDetailsData.splice()
      } catch (error) {
        console.error(error)
        this.$vs.notify({
          title: 'Warning',
          text: error.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    async haldleDelete () {
      try {
        const deleting_id = this.DeleteTaskId
        const payload = {
          deleteFields: [deleting_id]
        }
        const response = await taskDelete(
          localStorage.getItem('customer_id'),
          payload
        )

        if (response.status === 200 || response.status === 202) {
          if (response.data.data.status) {
            console.log(response.data.data.status)
            this.additionalPopUp = true
            this.nonDeletableItems = response.data.data.nonDeletableEntity.map(
              item => {
                return item.name
              }
            )
          } else {
            this.SET_DELETE_LIVE_ID(deleting_id)
            this.$vs.notify({
              title: 'Task Deleted',
              text: 'Task Deleted Successfully',
              ...this.successProp()
            })
          }
        }
      } catch (error) {
        console.error(error)
        this.$vs.notify({
          title: 'Warning',
          text: error.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },
    async handleStatusChnage (id, status_id) {
      try {
        const task_id = id
        const payload = {
          updateField: {
            task_status_id: status_id
          }
        }
        taskUpdate(localStorage.getItem('customer_id'), task_id, payload)
          .then(res => {
            // this.SET_PRIORITY(task_id)
            // this.SET_PRIORITY_ID(this.status)
            this.$vs.notify({
              title: 'Success',
              text: 'Task Updated Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          .catch(e => {
            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          })
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e,
          ...this.warnProp()
        })
      }
      /*   } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Sorry! you don\'t have permission to edit',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } */
    },
    addLog () {
      this.logs.push({
        no_of_days: '',
        no_of_hours: ''
      })
    },
    async loadMoreProject ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const res = await projectList(localStorage.getItem('customer_id'), {
            page: this.projectListMeta.current_page + 1
          })
          this.projectList.push(...res.data.data.project)
          this.projectListMeta = res.data.data.meta
        } catch (e) {}

        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenProject () {
      if (this.projectListMeta.has_next) {
        await this.$nextTick()
        this.observerUser.observe(this.$refs.loadProject)
      }
    },
    onCloseProject () {
      this.observerUser.disconnect()
    },
    getImportFile ({ file_id, fileInfo }) {
      fileInfo.forEach(eachFile => {
        this.editorComponent.insertContent(
          `<img src="${eachFile.file_path}" width="auto" height="auto"/>`
        )
      })
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
    },
    gDrive (editor) {
      this.editorComponent = editor
      this.driveIconClicked('Tasks')
    },
    importModelRepo (editor) {
      this.editorComponent = editor
      this.isBrowseContent = true
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      console.log('hi')
      const res = await getUploadedFilesId(file_id_payload)

      // console.log()
      const filesDriveInfo = res.data.data.files
      if (type === 'drive') {
        filesDriveInfo.forEach(eachFile => {
          if (eachFile.file_type.split('/')[0] === 'image') {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            )
          } else if (eachFile.file_type.split('/')[0] === 'video') {
            this.editorComponent.insertContent(
              `<video width="200" height="300"<source src="${eachFile.file_path}"</video>`
            )
          } else if (eachFile.file_type.split('/')[0] === 'audio') {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            )
          }
        })
        console.log(filesDriveInfo)
      }
    },
    replaceURLs (message) {
      if (!message) return
      const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
      return message.replace(urlRegex, function (url) {
        let hyperlink = url
        // eslint-disable-next-line no-useless-escape
        if (!hyperlink.match('^https?://')) {
          hyperlink = `http://${hyperlink}`
        }
        return `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">${url}</a>`
      })
    },
    checkPermissionForStaff () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Tasks')
        this.getModulePermission('Projects')
      }
    },
    updateCalendar () {
      if (this.taskData.due_date) {
        if (
          this.taskData.due_date.split(' ')[0] !==
          this.changedDataForFlatpicker.dueDate.split(' ')[0]
        ) {
          this.taskData.from_time = ''
          this.taskData.to_time = ''
        }
        this.configdateTimePicker.maxDate = this.taskData.due_date.split(
          ' '
        )[0]
        this.configdateTimePicker.maxTime = this.taskData.due_date.split(
          ' '
        )[1]
      }
    },

    // changeToTime () {
    //   if (this.configdateTimePicker.maxDate == this.taskData.due_date.split(' ')[0]) {
    //     this.configdateTimePicker.maxTime = this.taskData.due_date.split(' ')[1]
    //   } else {
    //     this.configdateTimePicker.maxTime = ''
    //   }
    // },
    checkWhenClose (fromWhere) {
      if (
        this.taskData.from_time.split(' ')[0] <=
        this.taskData.to_time.split(' ')[0]
      ) {
        console.log('right')
      } else {
        console.log('wrong')
        if (fromWhere == 'from') {
          this.taskData.to_time = ''
        } else {
          this.taskData.from_time = ''
        }
      }
    },
    priorityList () {
      priorityList()
        .then(res => {
          this.priority = res.data.data.priorities
        })
        .catch(e => {})
    },
    listOfTag (query) {
      const payload = {
        platform_module_id: 45
      }
      tagList(localStorage.getItem('customer_id'), query, payload)
        .then(res => {
          this.tag_meta = res.data.data.meta
          this.tagsList = res.data.data.tags
        })
        .catch(e => {})
    },
    fetchUserBySearch () {
      this.searchUser(this)
    },
    fetchClientBySearch () {
      this.searchClient(this)
    },
    searchUser: _.debounce(async vm => {
      try {
        const payload = {
          name: vm.searchName,
          source: true
        }
        const res = await fetchUserClient(
          'User',
          localStorage.getItem('customer_id'),
          vm.query_page_user,
          payload
        )
        vm.userList = res.data.data.users_list
        vm.showButtonUser = res.data.data.meta.has_next
      } catch (e) {
        console.log(e)
      }
    }, 350),
    searchClient: _.debounce(async vm => {
      try {
        const payload = {
          name: vm.searchName,
          source: true
        }
        const res = await fetchUserClient(
          'Client',
          localStorage.getItem('customer_id'),
          vm.query_page_user,
          payload
        )
        vm.clientList = res.data.data.users_list
        vm.showButtonClient = res.data.data.meta.has_next
      } catch (e) {
        console.log(e)
      }
    }, 350),
    fetchUser () {
      const payload = {
        name: this.searchName,
        source: true
      }
      fetchUserClient(
        'User',
        localStorage.getItem('customer_id'),
        this.query_page_user,
        payload
      )
        .then(res => {
          this.userList = res.data.data.users_list
          this.showButtonUser = res.data.data.meta.has_next
        })
        .catch(e => {})
    },
    fetchClient () {
      const payload = {
        name: this.searchName,
        source: true
      }
      fetchUserClient(
        'Client',
        localStorage.getItem('customer_id'),
        this.query_page_client,
        payload
      )
        .then(res => {
          this.clientList = res.data.data.users_list
          this.showButtonClient = res.data.data.meta.has_next
        })
        .catch(e => {})
    },
    showMoreUser () {
      this.query_page_user.page = this.query_page_user.page + 1
      this.currentPageUser = this.query_page_user.page
      this.fetchUser()
    },
    showMoreClient () {
      this.query_page_client.page = this.query_page_client.page + 1
      this.currentPageClient = this.query_page_client.page
      this.fetchClient()
    },
    showBackUser () {
      this.query_page_user.page = this.currentPageUser - 1
      this.currentPageUser = this.query_page_user.page
      this.fetchUser()
    },
    showBackClient () {
      this.query_page_client.page = this.currentPageClient - 1
      this.currentPageClient = this.query_page_client.page
      this.fetchClient()
    },
    closeSelected (data, index) {
      if (this.update_id) {
        if (data === 'Responsible') {
          if (this.taskData.clientResponsiblePerson.length !== 0) {
            this.taskData.clientResponsiblePerson.splice(index, 1)
          }
          if (this.taskData.userResponsiblePerson.length !== 0) {
            this.taskData.userResponsiblePerson.splice(index, 1)
          }
        }
      }
      if (this.live_update_id) {
        if (data === 'Responsible') {
          if (this.taskData.clientResponsiblePerson.length !== 0) {
            this.taskData.clientResponsiblePerson.splice(index, 1)
          }
          if (this.taskData.userResponsiblePerson.length !== 0) {
            this.taskData.userResponsiblePerson.splice(index, 1)
          }
        } else if (data === 'Participants') {
          if (this.taskData.clientParticipant.length !== 0) {
            this.taskData.clientParticipant.splice(index, 1)
          }
          if (this.taskData.userParticipant.length !== 0) {
            this.taskData.userParticipant.splice(index, 1)
          }
        } else {
          if (this.taskData.clientObserver.length !== 0) {
            this.taskData.clientObserver.splice(index, 1)
          }
          if (this.taskData.userObserver.length !== 0) {
            this.taskData.userObserver.splice(index, 1)
          }
        }
      }

      if (data === 'Responsible') {
        this.responsibleData.splice(index, 1)
      } else if (data === 'Participants') {
        this.participantData.splice(index, 1)
      } else if (data === 'projects') {
        this.selectedProjectsData.splice(index, 1)
      } else if (data === 'CRM') {
        this.selectedCRMData.splice(index, 1)
      } else if (data === 'subTask') {
        this.selectedSubTaskData.splice(index, 1)
      } else {
        this.observerData.splice(index, 1)
      }
    },
    addMoreUser (data) {
      this.typeOfPerson = data
      if (data === 'Responsible') {
        this.typeOfPersonTitle = 'Add Responsible Person'
        this.popupresponse = true
      } else {
        this.typeOfPersonTitle = `Add ${data}`
        this.popupActive = true
      }
    },
    addUser () {
      const arr = []
      console.log(this.typeOfPerson)
      if (this.typeOfPerson === 'Responsible') {
        
        if (Object.keys(this.selectedUsers).length > 1 && Object.keys(this.selectedClients).length > 1) {
          this.selectedUsers = []
          this.selectedClients = []
          return this.warningPopupMessage('Only one resposible person is allows')
        }

        if (Object.keys(this.selectedUsers).length > 0) {
          arr.push({
            first_name: this.selectedUsers.first_name,
            last_name: this.selectedUsers.last_name,
            user_type: this.selectedUsers.user_type,
            users_id: this.selectedUsers.users_id,
            picture: this.selectedUsers.picture
          })
        }
        if (Object.keys(this.selectedClients).length > 0) {
          arr.push({
            first_name: this.selectedClients.first_name,
            last_name: this.selectedClients.last_name,
            user_type: this.selectedClients.user_type,
            users_id: this.selectedClients.client_users_id,
            picture: this.selectedClients.picture
          })
        }
      } else {
        for (let i = 0; i < this.selectedUsers.length; i++) {
          arr.push({
            first_name: this.selectedUsers[i].first_name,
            last_name: this.selectedUsers[i].last_name,
            user_type: this.selectedUsers[i].user_type,
            users_id: this.selectedUsers[i].users_id,
            picture: this.selectedUsers[i].picture
          })
        }
        for (let i = 0; i < this.selectedClients.length; i++) {
          arr.push({
            first_name: this.selectedClients[i].first_name,
            last_name: this.selectedClients[i].last_name,
            user_type: this.selectedClients[i].user_type,
            users_id: this.selectedClients[i].client_users_id,
            picture: this.selectedClients[i].picture
          })
        }
      }

      if (this.typeOfPerson === 'Responsible') {
        const res2 = this.responsibleData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.responsibleData = this.responsibleData.filter(
              item => item.users_id !== idToRemove
            )
          }
        }
        this.responsibleData = arr.concat(this.responsibleData)
      } else if (this.typeOfPerson === 'Participants') {
        const res2 = this.participantData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.participantData = this.participantData.filter(
              item => item.users_id !== idToRemove
            )
          }
        }
        this.participantData = arr.concat(this.participantData)
        console.log(this.participantData)
      } else {
        const res2 = this.observerData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.users_id === o2.users_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].users_id
            this.observerData = this.observerData.filter(
              item => item.users_id !== idToRemove
            )
          }
        }
        this.observerData = arr.concat(this.observerData)
      }
      this.selectedUsers = []
      this.selectedClients = []
      this.popupActive = false
      this.popupresponse = false
      this.searchName = ''
    },
    addItem (checklist) {
      checklist.showTextBox.push({ itemName: '' })
    },
    addItemNewTask (id) {
      console.log(this.taskData.checklist)
      this.taskData.checklist[id].showTextBox.push({ itemName: '' })
      this.RenderKey = !this.RenderKey
    },
    submitItemNewTask (index3, data) {
      for (let index = 0; index < data.showTextBox.length; index++) {
        if (data.showTextBox[index].itemName !== '') {
          this.taskData.checklist[index3].todos.push({
            todo: data.showTextBox[index].itemName,
            is_completed: false
          })
        }
      }
      for (let index = 0; index < data.showTextBox.length; index++) {
        data.showTextBox[index].itemName = ''
      }
      this.taskData.checklist[index3].showTextBox = []
    },
    removeItem (data, index2) {
      data.showTextBox.splice(index2, 1)
    },
    removeItemNewTask (index, index2) {
      this.taskData.checklist[index].showTextBox.splice(index2, 1)
    },
    addChecklist () {
      this.checklistRows.push({
        name: '',
        showTextBox: [],
        items: [],
        itemStatusCal: []
      })
    },
    removeChecklist (index) {
      this.checklistRows.splice(index, 1)
    },
    submitItem (index3, data) {
      for (let index = 0; index < data.showTextBox.length; index++) {
        if (data.showTextBox[index].itemName !== '') {
          this.checklistRows[index3].items.push({
            todo: data.showTextBox[index].itemName,
            is_completed: false
          })
        }
      }
      for (let index = 0; index < data.showTextBox.length; index++) {
        data.showTextBox[index].itemName = ''
      }
      this.checklistRows[index3].showTextBox = []
    },
    editItemFromCheck (index3, index6, data) {
      this.editChecklistName = data.todo
      this.checklistEditPopup = true
      this.checkIndex = index3
      this.itemIndex = index6
    },
    editItem (index3, index6, data) {
      this.editChecklistName = data.todo
      this.checklistEditPopup2 = true
      this.checkIndex = index3
      this.itemIndex = index6
    },
    updateItem () {
      if (this.live_update_id) {
        if (this.editChecklistName !== '') {
          this.taskData.checklist[this.checkIndex].todos[
            this.itemIndex
          ].todo = this.editChecklistName
          this.checklistEditPopup2 = false
        }
      }
    },
    updateItemForCheck () {
      if (this.editChecklistName !== '') {
        this.checklistRows[this.checkIndex].items[
          this.itemIndex
        ].todo = this.editChecklistName
        this.checklistEditPopup = false
      }
    },
    deleteItem (index3, index) {
      if (this.live_update_id) {
        if (this.taskData.checklist.length !== 0) {
          if (this.taskData.checklist[index3].todos.length === 1) {
            this.taskData.checklist.splice(index3, 1)
          } else {
            if (
              this.taskData.checklist[index3].todos[index].is_completed === true
            ) {
              this.taskData.checklist[index3].itemStatusCal.length =
                this.taskData.checklist[index3].itemStatusCal.length - 1
            }
            this.taskData.checklist[index3].todos.splice(index, 1)
          }
        }
      }
    },
    deleteItemFromCheck (index3, index) {
      if (this.checklistRows.length !== 0) {
        if (this.checklistRows[index3].items.length === 1) {
          this.checklistRows.splice(index3, 1)
        } else {
          if (this.checklistRows[index3].items[index].is_completed === true) {
            this.checklistRows[index3].itemStatusCal.length =
              this.checklistRows[index3].itemStatusCal.length - 1
          }
          this.checklistRows[index3].items.splice(index, 1)
        }
      }
    },
    changeStatus (index3, index) {
      if (this.taskData.checklist.length !== 0) {
        if (
          this.taskData.checklist[index3].todos[index].is_completed === true
        ) {
          this.taskData.checklist[index3].todos[index].is_completed = true
          this.taskData.checklist[index3].itemStatusCal.length =
            this.taskData.checklist[index3].itemStatusCal.length + 1
        } else {
          this.taskData.checklist[index3].todos[index].is_completed = false
          this.taskData.checklist[index3].itemStatusCal.length =
            this.taskData.checklist[index3].itemStatusCal.length - 1
        }
      }
    },
    changeStatusFromCheck (index3, index) {
      if (this.checklistRows.length !== 0) {
        if (this.checklistRows[index3].items[index].is_completed === true) {
          this.checklistRows[index3].items[index].is_completed = true
          this.checklistRows[index3].itemStatusCal.length =
            this.checklistRows[index3].itemStatusCal.length + 1
        } else {
          this.checklistRows[index3].items[index].is_completed = false
          this.checklistRows[index3].itemStatusCal.length =
            this.checklistRows[index3].itemStatusCal.length - 1
        }
      }
    },
    clearData () {
      this.taskData.name = ''
      this.taskData.checklist = []
      this.taskData.due_date = ''
      this.taskData.status = ''
      this.taskData.projectStatusTag = ''
      this.taskData.task_priority_id = ''
      this.taskData.task_status_id = ''
      this.taskData.comments = ''
      this.taskData.details = ''
      this.taskData.clientObserver = []
      this.taskData.clientParticipant = []
      this.taskData.clientResponsiblePerson = []
      this.taskData.userObserver = []
      this.taskData.userParticipant = []
      this.taskData.userResponsiblePerson = []
      this.taskData.from_time = ''
      this.taskData.to_time = ''
      this.taskData.is_template = false
      this.taskData.project = null
      this.taskData.subtask = []
      this.taskData.reminder = []
      this.taskData.is_tracking_active = false
      this.taskData.created_by = {}
      this.taskData.leads = []
      this.taskData.tags = []
      this.responsibleData = []
      this.participantData = []
      this.observerData = []
      this.selectedSubTaskData = []
      this.selectedCRMData = []
      this.selectedProjectsData = []
      this.reminderTime = []
      this.update_id = ''
      this.live_update_id = ''
      this.checklistRows = []
      this.configdateTimePicker.maxDate = ''
    },
    submitTaskData () {
      this.taskData.from_time = this.taskData.from_time.length < 8 && this.taskData.from_time !== '' ? `${this.taskData.from_time}:00` : this.taskData.from_time
      this.taskData.to_time = this.taskData.to_time.length < 8 && this.taskData.to_time !== '' ? `${this.taskData.to_time}:00` : this.taskData.to_time
      if (
        this.taskData.is_template === '1' ||
        this.taskData.is_template === true
      ) {
        this.taskData.is_template = true
      } else {
        this.taskData.is_template = false
      }
      if (this.responsibleData.length !== 0) {
        for (let i = 0; i < this.responsibleData.length; i++) {
          if (this.responsibleData[i].user_type === 0) {
            this.taskData.userResponsiblePerson.push(
              this.responsibleData[i].users_id
            )
          } else {
            this.taskData.clientResponsiblePerson.push(
              this.responsibleData[i].users_id
            )
          }
        }
      }
      if (this.selectedProjectsData.length !== 0) {
        for (let i = 0; i < this.selectedProjectsData.length; i++) {
          this.taskData.projects.push(this.selectedProjectsData[i].id)
        }
      }
      if (this.selectedSubTaskData.length !== 0) {
        for (let i = 0; i < this.selectedSubTaskData.length; i++) {
          this.taskData.subtask.push(this.selectedSubTaskData[i].id)
        }
      }
      if (this.selectedCRMData.length !== 0) {
        for (let i = 0; i < this.selectedCRMData.length; i++) {
          this.taskData.leads.push(this.selectedCRMData[i].leads_id)
        }
      }
      if (this.reminderTime.length !== 0) {
        for (let i = 0; i < this.reminderTime.length; i++) {
          this.taskData.reminder.push({
            reminder_type: 1,
            reminder_time: this.reminderTime[i].reminder_time
          })
        }
      }
      if (this.participantData.length !== 0) {
        for (let i = 0; i < this.participantData.length; i++) {
          if (this.participantData[i].user_type === 0) {
            this.taskData.userParticipant.push(
              this.participantData[i].users_id
            )
          } else {
            this.taskData.clientParticipant.push(
              this.participantData[i].users_id
            )
          }
        }
      }
      if (this.observerData.length !== 0) {
        for (let i = 0; i < this.observerData.length; i++) {
          if (this.observerData[i].user_type === 0) {
            this.taskData.userObserver.push(this.observerData[i].users_id)
          } else {
            this.taskData.clientObserver.push(this.observerData[i].users_id)
          }
        }
      }
      for (let index = 0; index < this.checklistRows.length; index++) {
        if (this.checklistRows[index].items.length === 0) {
          this.checklistRows.splice(index, 1)
        } else {
          const result = this.checklistRows[index].items.map(function (el) {
            const o = Object.assign({}, el)
            o.order_id = 0
            return o
          })
          for (let j = 0; j < result.length; j++) {
            this.checklistRows[index].items[j].order_id = j + 1
          }
          this.taskData.checklist.push({
            name: this.checklistRows[index].name,
            todos: this.checklistRows[index].items
          })
        }
      }
      console.log(this.taskData)
      if (
        this.taskData.is_template === null ||
        this.taskData.is_template === false
      ) {
        if (this.responsibleData.length !== 0) {
          this.createTem(this.taskData, this.taskData.is_template)
        } else {
          this.warningPopupMessage('Responsible person is required')
        }
      } else {
        this.createTem(this.taskData, this.taskData.is_template)
      }
    },
    createTem (data, showTab) {
      taskCreate(localStorage.getItem('customer_id'), data)
        .then(res => {
          this.successPopupMessage('Task Created Successfully')
          const QueryParams = {
            template: showTab === true,
            livetask: showTab !== true,
            project: false
          }
          this.$router
            .push({
              name: 'tasks-project',
              params: { payload: QueryParams }
            })
            .catch(() => {})
          this.clearData()
        })
        .catch(e => {
          this.warningPopupMessage('Something went wrong')
        })
    },
    updateTaskDataTemplate () {
      if (
        this.taskData.is_template === '1' ||
        this.taskData.is_template === true
      ) {
        this.taskData.is_template = true
      } else {
        this.taskData.is_template = false
      }
      this.taskData.userResponsiblePerson = []
      this.taskData.clientResponsiblePerson = []
      if (this.participantData.length !== 0) {
        for (let i = 0; i < this.participantData.length; i++) {
          if (this.participantData[i].user_type === 0) {
            this.taskData.userParticipant.push(
              this.participantData[i].users_id
            )
          } else {
            this.taskData.clientParticipant.push(
              this.participantData[i].users_id
            )
          }
        }
      }
      if (this.observerData.length !== 0) {
        for (let i = 0; i < this.observerData.length; i++) {
          if (this.observerData[i].user_type === 0) {
            this.taskData.userObserver.push(this.observerData[i].users_id)
          } else {
            this.taskData.clientObserver.push(this.observerData[i].users_id)
          }
        }
      }
      if (this.responsibleData.length !== 0) {
        for (let i = 0; i < this.responsibleData.length; i++) {
          if ('user_type' in this.responsibleData[i]) {
            if (this.responsibleData[i].user_type === 0) {
              this.taskData.userResponsiblePerson.push(
                this.responsibleData[i].users_id
              )
            } else {
              this.taskData.clientResponsiblePerson.push(
                this.responsibleData[i].users_id
              )
            }
          }
          if ('pivot' in this.responsibleData[i]) {
            if (this.responsibleData[i].pivot.responsible_persons_type === 0) {
              this.taskData.userResponsiblePerson.push(
                this.responsibleData[i].pivot.responsible_persons_id
              )
            } else {
              this.taskData.clientResponsiblePerson.push(
                this.responsibleData[i].pivot.responsible_persons_id
              )
            }
          }
        }
      }

      const payload = {
        updateField: this.taskData
      }

      if (
        this.taskData.is_template === null ||
        this.taskData.is_template === false
      ) {
        if (this.responsibleData.length !== 0) {
          this.updateTem(this.update_id, payload)
        } else {
          this.warningPopupMessage('Responsible person is required')
        }
      } else {
        this.updateTem(this.update_id, payload)
      }
    },
    updateTem (id, payload) {
      taskTemplateUpdate(localStorage.getItem('customer_id'), id, payload)
        .then(res => {
          res.data.data.task.status_list = this.priority
          res.data.data.task.checkEditPermission = this.checkEditPermission()
          res.data.data.task.checkDeletePermission = this.checkDeletePermission()
          const afterUpdate = [res.data.data.task]
          this.ListOfTaskUpdate = this.ListOfTaskUpdate.map(
            obj => afterUpdate.find(o => o.id === obj.id) || obj
          )
          this.successPopupMessage('Template Updated Successfully')
          this.openUpdateModal = false
          this.clearData()
        })
        .catch(e => {
          this.openUpdateModal = false
          this.warningPopupMessage('Something Went Wrong')
        })
    },
    updateTaskDataLive () {
      if (
        this.taskData.is_template === '1' ||
        this.taskData.is_template === true
      ) {
        this.taskData.is_template = true
      } else {
        this.taskData.is_template = false
      }
      this.taskData.userResponsiblePerson = []
      this.taskData.clientResponsiblePerson = []
      if (this.responsibleData.length !== 0) {
        for (let i = 0; i < this.responsibleData.length; i++) {
          if ('user_type' in this.responsibleData[i]) {
            if (this.responsibleData[i].user_type === 0) {
              this.taskData.userResponsiblePerson.push(
                this.responsibleData[i].users_id
              )
            } else {
              this.taskData.clientResponsiblePerson.push(
                this.responsibleData[i].users_id
              )
            }
          }
          if ('pivot' in this.responsibleData[i]) {
            if (this.responsibleData[i].pivot.responsible_persons_type === 0) {
              this.taskData.userResponsiblePerson.push(
                this.responsibleData[i].pivot.responsible_persons_id
              )
            } else {
              this.taskData.clientResponsiblePerson.push(
                this.responsibleData[i].pivot.responsible_persons_id
              )
            }
          }
        }
      }
      this.taskData.userParticipant = []
      this.taskData.clientParticipant = []
      if (this.participantData.length !== 0) {
        for (let i = 0; i < this.participantData.length; i++) {
          if ('user_type' in this.participantData[i]) {
            if (this.participantData[i].user_type === 0) {
              this.taskData.userParticipant.push(
                this.participantData[i].users_id
              )
            } else {
              this.taskData.clientParticipant.push(
                this.participantData[i].users_id
              )
            }
          }
          if ('pivot' in this.participantData[i]) {
            if (this.participantData[i].pivot.participants_type === 0) {
              this.taskData.userParticipant.push(
                this.participantData[i].pivot.participants_id
              )
            } else {
              this.taskData.clientParticipant.push(
                this.participantData[i].pivot.participants_id
              )
            }
          }
        }
      }
      this.taskData.userObserver = []
      this.taskData.clientObserver = []
      if (this.observerData.length !== 0) {
        for (let i = 0; i < this.observerData.length; i++) {
          if ('user_type' in this.observerData[i]) {
            if (this.observerData[i].user_type === 0) {
              this.taskData.userObserver.push(this.observerData[i].users_id)
            } else {
              this.taskData.clientObserver.push(this.observerData[i].users_id)
            }
          }
          if ('pivot' in this.observerData[i]) {
            if (this.observerData[i].pivot.observers_type === 0) {
              this.taskData.userObserver.push(
                this.observerData[i].pivot.observers_id
              )
            } else {
              this.taskData.clientObserver.push(
                this.observerData[i].pivot.observers_id
              )
            }
          }
        }
      }
      if (
        this.checklistRows.length !== 0 ||
        this.taskData.checklist.length !== 0
      ) {
        for (let index = 0; index < this.taskData.checklist.length; index++) {
          if ('todos' in this.taskData.checklist[index]) {
            for (
              let j = 0;
              j < this.taskData.checklist[index].todos.length;
              j++
            ) {
              this.taskData.checklist[index].todos[j].order_id = j + 1
            }
            if (this.taskData.checklist[index].todos.length === 0) {
              this.taskData.checklist.splice(index, 1)
            }
          }
        }
        for (let index = 0; index < this.checklistRows.length; index++) {
          if (this.checklistRows[index].items.length === 0) {
            this.checklistRows.splice(index, 1)
          } else {
            const result = this.checklistRows[index].items.map(function (el) {
              const o = Object.assign({}, el)
              o.order_id = 0
              return o
            })
            for (let j = 0; j < result.length; j++) {
              this.checklistRows[index].items[j].order_id = j + 1
            }
            this.taskData.checklist.push({
              name: `Checklist${this.taskData.checklist.length + index + 1}`,
              todos: this.checklistRows[index].items
            })
          }
        }
      }

      if (this.selectedSubTaskData.length !== 0) {
        for (let i = 0; i < this.selectedSubTaskData.length; i++) {
          this.taskData.subtask.push(this.selectedSubTaskData[i].id)
        }
      }
      if (this.selectedCRMData.length !== 0) {
        for (let i = 0; i < this.selectedCRMData.length; i++) {
          this.taskData.leads.push(this.selectedCRMData[i].leads_id)
        }
      }
      if (this.reminderTime.length !== 0) {
        for (let i = 0; i < this.reminderTime.length; i++) {
          this.taskData.reminder.push({
            id: this.reminderTime[i].id,
            reminder_type: 1,
            reminder_time: this.reminderTime[i].reminder_time
          })
        }
      }
      const payload = {
        updateField: this.taskData
      }
      taskUpdate(
        localStorage.getItem('customer_id'),
        this.live_update_id,
        payload
      )
        .then(res => {
          res.data.data.task.status_list = this.priority
          res.data.data.task.live_status_list = this.options
          res.data.data.task.checkEditPermission = this.checkEditPermission()
          res.data.data.task.checkDeletePermission = this.checkDeletePermission()
          res.data.data.task.row_index = this.editedRowIndex
          const afterUpdate = [res.data.data.task]
          this.ListOfLiveTaskUpdate = this.ListOfLiveTaskUpdate.map(
            obj => afterUpdate.find(o => o.id === obj.id) || obj
          )

          this.successPopupMessage('Task Updated Successfully')
          this.openUpdateModal = false
          this.clearData()
        })
        .catch(e => {
          this.openUpdateModal = false
          this.warningPopupMessage('Something Went Wrong')
        })
    },
    async fetchTaskUpdate (query, params) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await taskList(
          localStorage.getItem('customer_id'),
          query,
          params
        )
        const table = data.data.taskTemplates
        this.meta_template = data.data.meta_template
        table.map((row, index) => {
          const row_index = index + 1
          const status_list = this.priority
          const checkEditPermission = this.checkEditPermission()
          const checkDeletePermission = this.checkDeletePermission()
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
          Object.assign(row, { checkEditPermission })
          Object.assign(row, { checkDeletePermission })
        })
        this.ListOfTaskUpdate = table
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    async fetchLiveTaskUpdate (query, filterData = null) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        console.log(query)
        //query = Object.assign({}, query, )
        const { data } = await livetaskList(
          localStorage.getItem('customer_id'),
          query,
          filterData
        )
        this.meta_task = data.data.meta_task
        const liveTable = data.data.tasks
        liveTable.map((row, index) => {
          const row_index = index + 1
          const status_list = this.priority
          const live_status_list = this.options
          const checkEditPermission = this.checkEditPermission()
          const checkDeletePermission = this.checkDeletePermission()
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
          Object.assign(row, { live_status_list })
          Object.assign(row, { checkEditPermission })
          Object.assign(row, { checkDeletePermission })
        })
        this.ListOfLiveTaskUpdate = liveTable
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    submitLog (id) {
      const payload = {
        logs: this.logs
      }
      createLog(id, localStorage.getItem('customer_id'), payload)
        .then(res => {
          this.logs = [
            {
              no_of_days: '',
              no_of_hours: ''
            }
          ]
          for (let index = 0; index < res.data.data.tasks.length; index++) {
            this.logHistory.push({
              no_of_days: res.data.data.tasks[index].no_of_days,
              no_of_hours: res.data.data.tasks[index].no_of_hours
            })
          }
          this.successPopupMessage('Successfull')
        })
        .catch(e => {
          this.warningPopupMessage('Something Went Wrong')
        })
    },
    images_upload_handler (blobInfo, success, failure) {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)
      xhr.upload.onprogress = function (e) {
        // eslint-disable-next-line no-undef
        progress((e.loaded / e.total) * 100)
      }
      xhr.onload = function () {
        // let json
        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`)
          return
        }
        const json = JSON.parse(xhr.responseText)
        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`)
          return
        }
        success(json.location)
      }
      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        )
      }

      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`
      )

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())

      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success) {
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())
      const data = this.fileupload(formData)
      data
        .then(res => {
          const locationObject = {
            src: {
              value: {
                location: res
              }
            }
          }
          const stringify = JSON.stringify(res)
          const parse = JSON.parse(stringify)

          success(parse)
        })
        .catch(error => {})
    },
    async fileupload (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const responseImage = await contentFileUpload(customer_id, payload)
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path
        this.successPopupMessage('Image Uploaded Successfully')
        return location
      } catch (error) {}
    },
    mainTab (type) {
      if (type === 'task' || type === 'Tasks') {
        this.task = true
        this.project = false
      } else if (type === 'project' || type === 'Projects') {
        this.task = false
        this.project = true
      }
      setTimeout(() => {
        this.initializePopupMutationObserver()
      }, 0)
    },
    openModalSectionLive (data, type = null) {
      this.live_update_id = data.id
      taskShow(localStorage.getItem('customer_id'), this.live_update_id)
        .then(res => {
          const task = res.data.data.task
          this.responsibleData = task.userResponsiblePerson.concat(
            task.clientResponsiblePerson
          )
          this.participantData = task.userParticipant.concat(
            task.clientParticipant
          )
          this.observerData = task.userObserver.concat(task.clientObserver)
          this.projectStatusTagId = task.projectStatusTag
          this.tagName = task.tags
          this.taskData.name = task.name
          this.taskData.due_date = task.due_date
          this.changedDataForFlatpicker.dueDate = task.due_date
          this.taskData.task_priority_id = task.task_priority.id
          this.taskData.comments = task.comments
          this.taskData.created_by = task.created_by
          this.taskData.is_tracking_active = task.is_tracking_active
          this.taskData.details = task.details
          this.taskData.checklist = task.checklist.sort(
            (a, b) => parseFloat(a.order_id) - parseFloat(b.order_id)
          )
          this.taskData.task_status_id = task.status.id

          this.taskData.checklist.map((row, index) => {
            const itemStatusCal = this.taskData.checklist[index].todos.filter(
              ele => {
                return ele.is_completed === true
              }
            )
            Object.assign(row, { itemStatusCal })
          })

          this.taskData.checklist.map((row, index) => {
            const showTextBox = []
            Object.assign(row, { showTextBox })
          })

          this.taskData.from_time = task.from_time
          this.taskData.to_time = task.to_time
          this.logHistory = []
          for (let index = 0; index < task.logs.length; index++) {
            this.logHistory.push({
              no_of_days: task.logs[index].no_of_days,
              no_of_hours: task.logs[index].no_of_hours
            })
          }
          this.taskData.is_template = false
          this.taskData.details = task.details
          this.taskData.project = task.project.id
          this.taskData.clientObserver = task.clientObserver
          this.taskData.clientParticipant = task.clientParticipant
          this.taskData.clientResponsiblePerson = task.clientResponsiblePerson
          this.taskData.userObserver = task.userObserver
          this.taskData.userParticipant = task.userParticipant

          this.selectedSubTaskData = task.subtask
          this.showDataForProject = task.project
          for (let index = 0; index < task.tags.length; index++) {
            this.taskData.tags.push(task.tags[index].id)
          }
          this.selectedCRMData = task.leads
          if (task.taskReminder.length !== 0) {
            for (let index = 0; index < task.taskReminder.length; index++) {
              this.addReminder()
            }
            for (let index = 0; index < task.taskReminder.length; index++) {
              this.reminderTime[index].id = task.taskReminder[index].id
              this.reminderTime[index].reminder_time =
                task.taskReminder[index].reminder_time
            }
          }
          this.editedRowIndex = data.row_index
        })
        .catch(e => {})
      if (type !== null) {
        this.openUpdateModalDetails = true
      } else {
        this.openUpdateModal = true
      }
    },
    // showModalForEdit (item) {
    //   this.live_update_id = item.id
    //   taskShow(localStorage.getItem('customer_id'), item.id)
    //     .then((res) => {
    //       const task = res.data.data.task
    //       this.taskData.name = task.name
    //       this.taskData.due_date = task.due_date
    //       this.taskData.task_priority_id = task.task_priority.id
    //       this.taskData.comments = task.comments
    //       this.taskData.created_by = task.created_by
    //       this.taskData.is_tracking_active = task.is_tracking_active
    //       this.taskData.details = task.details
    //       this.taskData.task_status_id = task.status.id
    //       // this.taskData.projectStatusTag = task.projectStatusTag.name // data is not present
    //       this.taskData.checklist = task.checklist
    //       this.taskData.checklist.map((row, index) => {
    //         const itemStatusCal = this.taskData.checklist[index].todos.filter(ele => {
    //           return ele.is_completed === true
    //         })
    //         Object.assign(row, { itemStatusCal })
    //       })
    //       this.taskData.from_time = task.from_time
    //       this.taskData.to_time = task.to_time
    //       this.logHistory = []
    //       for (let index = 0; index < task.logs.length; index++) {
    //         this.logHistory.push({
    //           no_of_days: task.logs[index].no_of_days,
    //           no_of_hours: task.logs[index].no_of_hours
    //         })
    //       }
    //       this.taskData.is_template = false
    //       this.taskData.details = task.details
    //       this.taskData.clientObserver = task.clientObserver
    //       this.taskData.clientParticipant = task.clientParticipant
    //       this.taskData.clientResponsiblePerson = task.clientResponsiblePerson
    //       this.taskData.userObserver = task.userObserver
    //       this.taskData.userParticipant = task.userParticipant
    //       this.responsibleData = task.userResponsiblePerson.concat(task.clientResponsiblePerson)
    //       this.participantData = task.userParticipant.concat(task.clientParticipant)
    //       this.observerData = task.userObserver.concat(task.clientObserver)
    //       this.selectedSubTaskData = task.subtask
    //       this.showDataForProject = task.project
    //       for (let index = 0; index < task.tags.length; index++) {
    //         this.taskData.tags.push(task.tags[index].id)
    //       }
    //       this.selectedCRMData = task.leads
    //       if (task.taskReminder.length !== 0) {
    //         for (let index = 0; index < task.taskReminder.length; index++) {
    //           this.addReminder()
    //         }
    //         for (let index = 0; index < task.taskReminder.length; index++) {
    //           this.reminderTime[index].id = task.taskReminder[index].id
    //           this.reminderTime[index].reminder_time = task.taskReminder[index].reminder_time
    //         }
    //       }
    //     })
    //     .catch((e) => {

    //     })
    //   this.kanbanActive = true
    // },
    addModal (data) {
      if (data === 'project') {
        this.popupActiveProj = true
      } else if (data === 'subTask') {
        this.popupActiveSubTask = true
      } else {
        this.popupActiveCRM = true
      }
    },
    async fetchProject (query, filterData = null) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await projectList(
          localStorage.getItem('customer_id'),
          query,
          filterData
        )
        const table = data.data.project
        this.projectList = data.data.project

        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.$vs.loading.close()
        this.ListOfProject = table
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    addMicData (data) {
      if (data === 'project') {
        const arr = []
        for (let i = 0; i < this.selectedProjects.length; i++) {
          arr.push({
            name: this.selectedProjects[i].name,
            id: this.selectedProjects[i].id
          })
        }
        const res2 = this.selectedProjectsData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.id === o2.id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].id
            this.selectedProjectsData = this.selectedProjectsData.filter(
              item => item.id !== idToRemove
            )
          }
        }
        this.selectedProjectsData = arr.concat(this.selectedProjectsData)
        this.popupActiveProj = false
        this.selectedProjects = []
      } else if (data === 'subTask') {
        const arr = []
        for (let i = 0; i < this.selectedSubTask.length; i++) {
          arr.push({
            name: this.selectedSubTask[i].name,
            id: this.selectedSubTask[i].id
          })
        }
        const res2 = this.selectedSubTaskData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.id === o2.id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].id
            this.selectedSubTaskData = this.selectedSubTaskData.filter(
              item => item.id !== idToRemove
            )
          }
        }
        this.selectedSubTaskData = arr.concat(this.selectedSubTaskData)
        this.popupActiveSubTask = false
        this.selectedSubTask = []
      } else {
        const arr = []
        for (let i = 0; i < this.selectedCRM.length; i++) {
          arr.push({
            lead_first_name: this.selectedCRM[i].lead_first_name,
            leads_id: this.selectedCRM[i].leads_id
          })
        }
        const res2 = this.selectedCRMData
        const res1 = arr
        const result = res1.filter(function (o1) {
          return res2.some(function (o2) {
            return o1.leads_id === o2.leads_id // return the ones with equal id
          })
        })
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            const idToRemove = result[i].leads_id
            this.selectedCRMData = this.selectedCRMData.filter(
              item => item.leads_id !== idToRemove
            )
          }
        }
        this.selectedCRMData = arr.concat(this.selectedCRMData)
        this.popupActiveCRM = false
        this.selectedCRM = []
      }
    },
    async showProj (showType) {
      console.log('showProj', showType)
      console.log('current', this.meta.current_page)
      if (showType === 'plus') {
        this.meta.current_page = this.meta.current_page + 1
      } else {
        this.meta.current_page = this.meta.current_page - 1
      }
      this.fetchProject(this.meta)
    },
    async showCRM (showType, params = null) {
      this.$vs.loading({
        type: 'radius'
      })
      //console.log(this.leadMeta)
      if (showType === 'plus') {
        this.leadQuery.page = this.leadMeta.current_page + 1
      } else {
        this.leadQuery.page = this.leadMeta.current_page - 1
      }
      try {
        const { data } = await Lead_list(this.leadQuery, params)
        const table = data.data.results
        this.leadMeta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.is_active === '1',
            view: false
          }
          const row_index = index + 1
          const status_list = this.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        this.leadList = table
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    async fetchLeadList (params = null) {
      try {
        const { data } = await Lead_list(this.leadQuery, params)
        const table = data.data.results
        this.leadMeta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.is_active === '1',
            view: false
          }
          const row_index = index + 1
          const status_list = this.active_status_list
          Object.assign(row, { actionData })
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
        })
        this.leadList = table
      } catch (e) {}
    },
    async showSubTask (showType) {
      if (showType === 'plus') {
        this.sub_meta.current_page = this.sub_meta.current_page + 1
      } else {
        this.sub_meta.current_page = this.sub_meta.current_page - 1
      }
      this.parentTask(this.sub_meta.current_page)
    },
    addReminder () {
      this.reminderTime.push({ id: null, reminder_time: '' })
    },
    removeReminder (index) {
      this.reminderTime.splice(index, 1)
    },
    async parentTask (query) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await parentTask(
          localStorage.getItem('customer_id'),
          query
        )
        this.sub_meta = data.data.meta
        const liveTable = data.data.tasks
        liveTable.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.parentTaskData = liveTable
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
    },
    successPopupMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    warningPopupMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    }
  }
}
